// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import type { Dispatch } from 'redux';
import { Helmet } from 'react-helmet-async';

import { COMPARISON_ROUTE, TOP_ROUTE, ROOT_ROUTE } from 'client/constants';
import Comparison from 'client/components/Comparison';
import Top from 'client/components/Top';
import Intro from 'client/components/Intro';
// import Header from 'client/components/Header';
import type { Store } from 'client/reducers';

import * as css from './App.scss';

/**
 * detect IEEdge
 * returns version of IE/Edge or false, if browser is not a Microsoft browser
 */
function detectIE() {
	const ua = window.navigator.userAgent;

	const msie = ua.indexOf('MSIE ');
	if (msie > 0) {
		// IE 10 or older => return version number
		return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
	}

	const trident = ua.indexOf('Trident/');
	if (trident > 0) {
		// IE 11 => return version number
		const rv = ua.indexOf('rv:');
		return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
	}

	// other browser
	return false;
}

type Props = {};

type State = {};

class App extends React.PureComponent<Props, State> {
	componentDidMount() {
		const isIE = detectIE();
		document.body.setAttribute('data-browser', isIE ? 'ie' : 'not-ie');
	}

	render() {
		return (
			<div id="app" className={css.app}>
				<Helmet
					title="Matriculation Certificate"
					meta={[
						{ name: 'description', content: 'Matriculation Certificate' },
						{ property: 'og:title', content: 'Matriculation Certificate og:content' },
					]}
				/>
				{/* <Header /> */}

				<Switch>
					<Route exact path={ROOT_ROUTE} render={props => <Intro {...props} />} />
					<Route exact path={COMPARISON_ROUTE} render={props => <Comparison {...props} />} />
					<Route exact path={TOP_ROUTE} render={props => <Top {...props} />} />
				</Switch>
			</div>
		);
	}
}

const mapState = (store: Store): Props => ({});

const mapDispatch = (dispatch: Dispatch<{ type: string }>) => ({});

export default withRouter((connect(mapState, mapDispatch)(App): React.AbstractComponent<{}>));
